import { atom } from "jotai";
import { generateNewITR, getDownloadAuditLogs, getLockTrackerDetails, getPunchlist, getQCProgressColor, getQCPunchlistStatusWiseCounts, getReports, updateLockTrackers } from "../../services/Quality";
import { getProjectLists } from "../../services/settings/service";

const punchListAtom = atom({
    data: {},
    qcProgressColor: {},
    qcPunchlistStatusWiseCounts: {},
    lockTrackerData: {},
    tableData: {}
})

export const fetchReportsData =atom(
    null,
    async (get, set, args1,args2) => {
        let res = await getReports(args1,args2);
        if (res) {
            set(punchListAtom, (prev) => ({ ...prev, tableData: res.data }));
        }
    }
)


export const fetchpunchlistAtom = atom(
    null,
    async (get, set, args) => {
        let res = await getPunchlist(args);
        if (res) {
            set(punchListAtom, (prev) => ({ ...prev, data: res.data }));
        }
    }
)

export const fetchQCProgressAtom = atom(
    null,
    async (get, set, args) => {
        let res = await getQCProgressColor(args);
        if (res) {
            set(punchListAtom, (prev) => ({ ...prev, qcProgressColor: res.data }));
        }
    }
)
export const fetchQCPunchlistStatusCountsAtom = atom(
    null,
    async (get, set, args) => {
        let res = await getQCPunchlistStatusWiseCounts(args)
        if (res) {
            set(punchListAtom, (prev) => ({ ...prev, qcPunchlistStatusWiseCounts: res.data }));
        }
    }
)

export const fetchDownloadAuditLogsAtom = atom(
    null,
    async (get, set, args) => {
        let res = await getDownloadAuditLogs(args)
        let projectData = await getProjectLists()
        let project_name = projectData.data.find(p => p.id === parseInt(localStorage.getItem("project_id")))
        let csv = res.data
        const element = document.createElement("a");
        const file = new Blob([csv], { type: 'text/csv' });
        element.href = URL.createObjectURL(file);
        element.download = `${project_name?.project_number}_${args.activity_type === "cp" ? "CP" : "QC"}_Log_${project_name?.name}`
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
)

export const fetchGenerateNewITRAtom = atom(
    null,
    async (get, set, args) => {
        await generateNewITR(args)

    }
)
export const updateLockTrackersAtom = atom(
    null,
    async (get, set, args) => {
        await updateLockTrackers(args)
    }
)

export const fetchLockTrackerDetailsAtom = atom(
    null,
    async (get, set, args1, args2, args3) => {
        let res = await getLockTrackerDetails(args1, args2, args3)
        if (res) {
            set(punchListAtom, (prev) => ({ ...prev, lockTrackerData: res.data }));
        }
    }
)


export default punchListAtom;